import { getDomainMapKeyFromInstancePathReduxUtil } from 'modules/redux/utils/legacy/get-domain-map-from-instance-path'
import { setReduxUtil } from 'modules/redux/utils/legacy/set'
import { getObjectUtil } from 'packages/src'

/**
 * Deletes a instance from the given path.
 * If the instance is in a DomainMap, it gets removed from the DomainList.
 * @param  {Object} state
 * @param  {string} path
 * @param  {string} domainListPath
 * @returns {Object}
 */
function delReduxUtil (state, path, domainListPath) {
  // Remove it from the DomainList
  // e.g. `articles.all.data`
  if (domainListPath) {
    const domainListDataPath = `${domainListPath}.data`
    let domainListData = getObjectUtil(state, domainListDataPath)
    // Remove the instance from the list
    const key = getDomainMapKeyFromInstancePathReduxUtil(path)
    domainListData = domainListData.filter(k => k !== key)
    if (!domainListData.length) {
      // If the DomainList is empty, delete it
      state = setReduxUtil(state, domainListPath, undefined)
    } else {
      // Update the DomainList
      state = setReduxUtil(state, domainListDataPath, domainListData)
    }
  }
  return setReduxUtil(state, path, undefined)
}

export {
  delReduxUtil
}
